import React from 'react';
import { Button, Container, Paper, Typography } from '@mui/material';
import { BRAND_COLORS } from '../types/index.ts';

interface ErrorBoundaryState {
  hasError: boolean;
}

// React 18 démonte TOUT l'arbre quand une erreur de rendu n'est pas rattrapée
// (page blanche). Cette frontière transforme n'importe quel crash — WebGL
// indisponible, donnée inattendue — en message actionnable.
class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Box Finder: unexpected rendering error.', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Container maxWidth="sm">
        <Paper
          variant="outlined"
          sx={{ p: 4, m: 4, backgroundColor: BRAND_COLORS.cardStock, borderLeft: `4px solid ${BRAND_COLORS.red}` }}
        >
          <Typography variant="h6" gutterBottom sx={{ color: BRAND_COLORS.ink }}>
            Something went wrong
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
            The application hit an unexpected error. Your box database is safe — reload the page to
            continue.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload the page
          </Button>
        </Paper>
      </Container>
    );
  }
}

export default ErrorBoundary;
